import { Box, Container, Grid, Link, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const Mev = () => {
  return (
    <Container className="container-xxl my-4">
      <Box className="card p-4">
        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            Proposer Fee Recipient:
          </Grid>
          <Grid item xs={9}>
            <Box className="d-flex align-items-center gap-2">
              <Link href="/txs?block=8215859" target="_blank">
                0x2194331af2cF9dE9Adb36cf09654faD65cafb58b
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            MEV Reward:
          </Grid>
          <Grid item xs={9} className="text-dt">
            <Typography>0.091501497156026063 UPC</Typography>
          </Grid>
        </Grid>
        <Grid container className="mb-4">
          <Grid item xs={3} className="text-dt d-flex align-items-center">
            <HelpOutlineIcon fontSize="small" className="me-1" />
            MEV Payout Txn Hash:
          </Grid>
          <Grid item xs={9}>
            <Box className="d-flex align-items-center gap-2">
              <Link href="/txs?block=8215859" target="_blank">
                0xcf0d68c6e900dd7d64253d4aafa15d490871783e9dbac7ffc3a050dcc82fe781
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Mev;
